/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignRoleRequest,
  CreateRoleRequest,
  RoleListResponse,
  RoleResponse,
  StringListResponse,
  UpdateRoleRequest,
} from '../models/index';
import {
    AssignRoleRequestFromJSON,
    AssignRoleRequestToJSON,
    CreateRoleRequestFromJSON,
    CreateRoleRequestToJSON,
    RoleListResponseFromJSON,
    RoleListResponseToJSON,
    RoleResponseFromJSON,
    RoleResponseToJSON,
    StringListResponseFromJSON,
    StringListResponseToJSON,
    UpdateRoleRequestFromJSON,
    UpdateRoleRequestToJSON,
} from '../models/index';

export interface AssignRolesToUserRequest {
    assignRoleRequest: AssignRoleRequest;
    sessionId?: string;
}

export interface CreateRoleOperationRequest {
    createRoleRequest: CreateRoleRequest;
    sessionId?: string;
}

export interface DeleteRoleRequest {
    id: string;
    sessionId?: string;
}

export interface GetAvailablePermissionsRequest {
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetRoleRequest {
    id: string;
    sessionId?: string;
}

export interface GetRoleFieldPermissionsRequest {
    roleId: string;
    sessionId?: string;
}

export interface GetRolesRequest {
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    name?: string;
    sessionId?: string;
}

export interface GetUserRolesRequest {
    userId: string;
    sessionId?: string;
}

export interface RemoveRolesFromUserRequest {
    assignRoleRequest: AssignRoleRequest;
    sessionId?: string;
}

export interface UpdateRoleOperationRequest {
    id: string;
    updateRoleRequest: UpdateRoleRequest;
    sessionId?: string;
}

export interface UpdateRoleFieldPermissionsRequest {
    roleId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * RolesApi - interface
 * 
 * @export
 * @interface RolesApiInterface
 */
export interface RolesApiInterface {
    /**
     * Assigns multiple roles to a user
     * @summary Assign roles to user
     * @param {AssignRoleRequest} assignRoleRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    assignRolesToUserRaw(requestParameters: AssignRolesToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>>;

    /**
     * Assigns multiple roles to a user
     * Assign roles to user
     */
    assignRolesToUser(requestParameters: AssignRolesToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse>;

    /**
     * Creates a new role in the specified tenant context. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (tenantId from request.tenantId matches session tenant): - User creates role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (tenantId from request.tenantId differs from session tenant): - Parent/system admin creates role for child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to target tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * @summary Create role
     * @param {CreateRoleRequest} createRoleRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    createRoleRaw(requestParameters: CreateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>>;

    /**
     * Creates a new role in the specified tenant context. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (tenantId from request.tenantId matches session tenant): - User creates role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (tenantId from request.tenantId differs from session tenant): - Parent/system admin creates role for child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to target tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Create role
     */
    createRole(requestParameters: CreateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse>;

    /**
     * Deletes a role. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (role\'s tenant matches session tenant): - User deletes role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (role\'s tenant differs from session tenant): - Parent/system admin deletes role in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to role\'s tenant for write operation  Protected and system roles cannot be deleted. Access is controlled by RBAC permissions and tenant relationships. 
     * @summary Delete role
     * @param {string} id Role ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    deleteRoleRaw(requestParameters: DeleteRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a role. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (role\'s tenant matches session tenant): - User deletes role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (role\'s tenant differs from session tenant): - Parent/system admin deletes role in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to role\'s tenant for write operation  Protected and system roles cannot be deleted. Access is controlled by RBAC permissions and tenant relationships. 
     * Delete role
     */
    deleteRole(requestParameters: DeleteRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves all available permissions in the system
     * @summary Get available permissions
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    getAvailablePermissionsRaw(requestParameters: GetAvailablePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all available permissions in the system
     * Get available permissions
     */
    getAvailablePermissions(requestParameters: GetAvailablePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves a specific role by ID. Access is controlled by RBAC permissions and tenant relationships. Users can access roles from any tenant where they have roles:read permission.
     * @summary Get role by ID
     * @param {string} id Role ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    getRoleRaw(requestParameters: GetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>>;

    /**
     * Retrieves a specific role by ID. Access is controlled by RBAC permissions and tenant relationships. Users can access roles from any tenant where they have roles:read permission.
     * Get role by ID
     */
    getRole(requestParameters: GetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse>;

    /**
     * Retrieves field-level permissions assigned to a specific role
     * @summary Get field-level permissions for role
     * @param {string} roleId Role ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    getRoleFieldPermissionsRaw(requestParameters: GetRoleFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves field-level permissions assigned to a specific role
     * Get field-level permissions for role
     */
    getRoleFieldPermissions(requestParameters: GetRoleFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves paginated list of roles for the current tenant or across multiple tenants if user has cross-tenant relationships and appropriate permissions.  **Multi-Tenant Behavior:** - When multiple tenants are selected in the session, roles from all accessible tenants are returned - Each role includes tenant information (tenantId, tenantName) for clear identification - Roles with the same name from different tenants appear as separate records - Access is controlled by RBAC permissions and tenant relationships  **Tenant Selection:** - Uses session\'s selectedTenants for multi-tenant aggregation - Falls back to current tenant if no tenants are selected - Validates access to all requested tenants through relationships  **Examples:** - Single tenant: Returns roles from current tenant only - Multi-tenant: Returns roles from all selected tenants with tenant context - Cross-tenant: Returns roles from related tenants where user has roles:read permission 
     * @summary Get all roles
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [name] Role name filter
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    getRolesRaw(requestParameters: GetRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleListResponse>>;

    /**
     * Retrieves paginated list of roles for the current tenant or across multiple tenants if user has cross-tenant relationships and appropriate permissions.  **Multi-Tenant Behavior:** - When multiple tenants are selected in the session, roles from all accessible tenants are returned - Each role includes tenant information (tenantId, tenantName) for clear identification - Roles with the same name from different tenants appear as separate records - Access is controlled by RBAC permissions and tenant relationships  **Tenant Selection:** - Uses session\'s selectedTenants for multi-tenant aggregation - Falls back to current tenant if no tenants are selected - Validates access to all requested tenants through relationships  **Examples:** - Single tenant: Returns roles from current tenant only - Multi-tenant: Returns roles from all selected tenants with tenant context - Cross-tenant: Returns roles from related tenants where user has roles:read permission 
     * Get all roles
     */
    getRoles(requestParameters: GetRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleListResponse>;

    /**
     * Retrieves all roles assigned to a specific user
     * @summary Get user roles
     * @param {string} userId User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    getUserRolesRaw(requestParameters: GetUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleListResponse>>;

    /**
     * Retrieves all roles assigned to a specific user
     * Get user roles
     */
    getUserRoles(requestParameters: GetUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleListResponse>;

    /**
     * Removes multiple roles from a user
     * @summary Remove roles from user
     * @param {AssignRoleRequest} assignRoleRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    removeRolesFromUserRaw(requestParameters: RemoveRolesFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>>;

    /**
     * Removes multiple roles from a user
     * Remove roles from user
     */
    removeRolesFromUser(requestParameters: RemoveRolesFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse>;

    /**
     * Updates an existing role. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (role\'s tenant matches session tenant): - User updates role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (role\'s tenant differs from session tenant): - Parent/system admin updates role in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to role\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * @summary Update role
     * @param {string} id Role ID
     * @param {UpdateRoleRequest} updateRoleRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    updateRoleRaw(requestParameters: UpdateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>>;

    /**
     * Updates an existing role. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (role\'s tenant matches session tenant): - User updates role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (role\'s tenant differs from session tenant): - Parent/system admin updates role in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to role\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Update role
     */
    updateRole(requestParameters: UpdateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse>;

    /**
     * Updates field-level permissions for a specific role
     * @summary Update role field-level permissions
     * @param {string} roleId Role ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    updateRoleFieldPermissionsRaw(requestParameters: UpdateRoleFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Updates field-level permissions for a specific role
     * Update role field-level permissions
     */
    updateRoleFieldPermissions(requestParameters: UpdateRoleFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class RolesApi extends runtime.BaseAPI implements RolesApiInterface {

    /**
     * Assigns multiple roles to a user
     * Assign roles to user
     */
    async assignRolesToUserRaw(requestParameters: AssignRolesToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>> {
        if (requestParameters['assignRoleRequest'] == null) {
            throw new runtime.RequiredError(
                'assignRoleRequest',
                'Required parameter "assignRoleRequest" was null or undefined when calling assignRolesToUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/roles/assign`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignRoleRequestToJSON(requestParameters['assignRoleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponseFromJSON(jsonValue));
    }

    /**
     * Assigns multiple roles to a user
     * Assign roles to user
     */
    async assignRolesToUser(requestParameters: AssignRolesToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse> {
        const response = await this.assignRolesToUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new role in the specified tenant context. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (tenantId from request.tenantId matches session tenant): - User creates role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (tenantId from request.tenantId differs from session tenant): - Parent/system admin creates role for child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to target tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Create role
     */
    async createRoleRaw(requestParameters: CreateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>> {
        if (requestParameters['createRoleRequest'] == null) {
            throw new runtime.RequiredError(
                'createRoleRequest',
                'Required parameter "createRoleRequest" was null or undefined when calling createRole().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/roles`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRoleRequestToJSON(requestParameters['createRoleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new role in the specified tenant context. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (tenantId from request.tenantId matches session tenant): - User creates role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (tenantId from request.tenantId differs from session tenant): - Parent/system admin creates role for child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to target tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Create role
     */
    async createRole(requestParameters: CreateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse> {
        const response = await this.createRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a role. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (role\'s tenant matches session tenant): - User deletes role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (role\'s tenant differs from session tenant): - Parent/system admin deletes role in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to role\'s tenant for write operation  Protected and system roles cannot be deleted. Access is controlled by RBAC permissions and tenant relationships. 
     * Delete role
     */
    async deleteRoleRaw(requestParameters: DeleteRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteRole().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/roles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a role. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (role\'s tenant matches session tenant): - User deletes role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (role\'s tenant differs from session tenant): - Parent/system admin deletes role in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to role\'s tenant for write operation  Protected and system roles cannot be deleted. Access is controlled by RBAC permissions and tenant relationships. 
     * Delete role
     */
    async deleteRole(requestParameters: DeleteRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRoleRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves all available permissions in the system
     * Get available permissions
     */
    async getAvailablePermissionsRaw(requestParameters: GetAvailablePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/roles/permissions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all available permissions in the system
     * Get available permissions
     */
    async getAvailablePermissions(requestParameters: GetAvailablePermissionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getAvailablePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific role by ID. Access is controlled by RBAC permissions and tenant relationships. Users can access roles from any tenant where they have roles:read permission.
     * Get role by ID
     */
    async getRoleRaw(requestParameters: GetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRole().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/roles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific role by ID. Access is controlled by RBAC permissions and tenant relationships. Users can access roles from any tenant where they have roles:read permission.
     * Get role by ID
     */
    async getRole(requestParameters: GetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse> {
        const response = await this.getRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves field-level permissions assigned to a specific role
     * Get field-level permissions for role
     */
    async getRoleFieldPermissionsRaw(requestParameters: GetRoleFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling getRoleFieldPermissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/roles/{roleId}/field-permissions`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves field-level permissions assigned to a specific role
     * Get field-level permissions for role
     */
    async getRoleFieldPermissions(requestParameters: GetRoleFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRoleFieldPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of roles for the current tenant or across multiple tenants if user has cross-tenant relationships and appropriate permissions.  **Multi-Tenant Behavior:** - When multiple tenants are selected in the session, roles from all accessible tenants are returned - Each role includes tenant information (tenantId, tenantName) for clear identification - Roles with the same name from different tenants appear as separate records - Access is controlled by RBAC permissions and tenant relationships  **Tenant Selection:** - Uses session\'s selectedTenants for multi-tenant aggregation - Falls back to current tenant if no tenants are selected - Validates access to all requested tenants through relationships  **Examples:** - Single tenant: Returns roles from current tenant only - Multi-tenant: Returns roles from all selected tenants with tenant context - Cross-tenant: Returns roles from related tenants where user has roles:read permission 
     * Get all roles
     */
    async getRolesRaw(requestParameters: GetRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/roles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of roles for the current tenant or across multiple tenants if user has cross-tenant relationships and appropriate permissions.  **Multi-Tenant Behavior:** - When multiple tenants are selected in the session, roles from all accessible tenants are returned - Each role includes tenant information (tenantId, tenantName) for clear identification - Roles with the same name from different tenants appear as separate records - Access is controlled by RBAC permissions and tenant relationships  **Tenant Selection:** - Uses session\'s selectedTenants for multi-tenant aggregation - Falls back to current tenant if no tenants are selected - Validates access to all requested tenants through relationships  **Examples:** - Single tenant: Returns roles from current tenant only - Multi-tenant: Returns roles from all selected tenants with tenant context - Cross-tenant: Returns roles from related tenants where user has roles:read permission 
     * Get all roles
     */
    async getRoles(requestParameters: GetRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleListResponse> {
        const response = await this.getRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all roles assigned to a specific user
     * Get user roles
     */
    async getUserRolesRaw(requestParameters: GetUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleListResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/roles/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all roles assigned to a specific user
     * Get user roles
     */
    async getUserRoles(requestParameters: GetUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleListResponse> {
        const response = await this.getUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes multiple roles from a user
     * Remove roles from user
     */
    async removeRolesFromUserRaw(requestParameters: RemoveRolesFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>> {
        if (requestParameters['assignRoleRequest'] == null) {
            throw new runtime.RequiredError(
                'assignRoleRequest',
                'Required parameter "assignRoleRequest" was null or undefined when calling removeRolesFromUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/roles/assign`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: AssignRoleRequestToJSON(requestParameters['assignRoleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponseFromJSON(jsonValue));
    }

    /**
     * Removes multiple roles from a user
     * Remove roles from user
     */
    async removeRolesFromUser(requestParameters: RemoveRolesFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse> {
        const response = await this.removeRolesFromUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing role. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (role\'s tenant matches session tenant): - User updates role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (role\'s tenant differs from session tenant): - Parent/system admin updates role in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to role\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Update role
     */
    async updateRoleRaw(requestParameters: UpdateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateRole().'
            );
        }

        if (requestParameters['updateRoleRequest'] == null) {
            throw new runtime.RequiredError(
                'updateRoleRequest',
                'Required parameter "updateRoleRequest" was null or undefined when calling updateRole().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/roles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRoleRequestToJSON(requestParameters['updateRoleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing role. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (role\'s tenant matches session tenant): - User updates role in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (role\'s tenant differs from session tenant): - Parent/system admin updates role in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to role\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Update role
     */
    async updateRole(requestParameters: UpdateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse> {
        const response = await this.updateRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates field-level permissions for a specific role
     * Update role field-level permissions
     */
    async updateRoleFieldPermissionsRaw(requestParameters: UpdateRoleFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling updateRoleFieldPermissions().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateRoleFieldPermissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/roles/{roleId}/field-permissions`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates field-level permissions for a specific role
     * Update role field-level permissions
     */
    async updateRoleFieldPermissions(requestParameters: UpdateRoleFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateRoleFieldPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
